export const locales = {
  'en-US': require('./en-US.json'),
  'zh-CN': require('./zh-CN.json'),
  'ja-JP': require('./ja-JP.json'),
};
